import { View, TextInput, Text, StyleSheet, TouchableOpacity, ActivityIndicator } from 'react-native';
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Colors } from '../constants/theme';
import Button from '../components/Button';
import useDataStore from '../stores/dataStore';
import { FontAwesome5, Feather } from '@expo/vector-icons';
import { useNavigation, useIsFocused } from '@react-navigation/native';
import ShowAlert from "../modules/AlertModule";
import { USERS_API } from "../env-config/api-config";
import { sendNotification } from "../modules/Notification";
import { APP_ROLE, EVENT_ACTIONS } from '../constants/Constant';
import { handleAlertForError } from '../utils/handleError';
import MixpanelTracker from '../utils/MixpanelTracker';
import { formatDate } from '../utils/dateUtil';
import { isEmpty, removeLeadingZero } from '../utils/commonUtils';
import { makeApiRequest } from '../utils/apiUtil';
import DateTimePicker from 'react-native-ui-datepicker';
import Popup from "../components/popup";

const AddOtherIncome = ({ route }) => {
    const [amount, setAmount] = useState('');
    const [isFocus, setIsFocus] = useState(null);
    const [incomeAccountList, setIncomeAccountList] = useState([]);
    const [value, setValue] = useState(null);
    const [API_CONFIG, userData, setToastMessage, authToken, refreshToken, setAuthToken, setRefreshToken] = useDataStore((state) => ([state.API_CONFIG, state.userData, state.setToastMessage, state.authToken, state.refreshToken, state.setAuthToken, state.setRefreshToken]));
    const [error, setError] = useState(null);
    const [comment, setComment] = useState('');
    const [chosenDate, setChosenDate] = useState(new Date());
    const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
    const { existingAmount, existingComment, accountType, commentFactoryExpense, transactionId, accountName } = route.params || { existingAmount: null, existingComment: null, incomeType: null, commentFactoryExpense: null, transactionId: null, accountName: null };
    const navigation = useNavigation();
    const [loading, setLoading] = useState(false);
    const isFocused = useIsFocused();
    let dataResponse = false;

    useEffect(() => {
        const fetchDataOnFocus = async () => {
            if (isFocused) {
                dataResponse = await fetchData();
            }
        };
        fetchDataOnFocus();
    }, [isFocused]);
    useLayoutEffect(() => {
        if (existingAmount) {
            navigation.setOptions({
                title: `Edit Income`,
            });
        }
        else {
            navigation.setOptions({
                title: "Other Income",
                headerRight: () => (
                    <Button
                        onPress={handleDeleteButton}
                        btnLabel={<Feather name="trash-2" size={24} color={Colors.accent} />}
                        textStyle={styles.trashIcon}
                        buttonStyle={{ backgroundColor: null, }}
                        allowedRole={[APP_ROLE.OWNER]}
                    />
                ),
            });
        }
    }, [navigation]);

    useEffect(() => {
        if (existingAmount && existingComment) setAmount(existingAmount); setComment(commentFactoryExpense); setValue(accountType);
    }, [existingAmount, existingComment])

    let time = new Date();
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    function findLabelByValue(value) {
        for (var i = 0; i < incomeAccountList.length; i++) {
            if (incomeAccountList[i].value === value) {
                return incomeAccountList[i].label;
            }
        }
        return null;
    }

    useEffect(() => {
        checkExistingIncomeAccounts();
    }, []);

    const handleDeleteButton = () => {
        if (dataResponse === true) {
            ShowAlert("Failed", "Please Delete all the transactions", "Ok");
        }
        else {
            ShowAlert("Delete", `Are you sure you want to delete this account?`, "YesNo", () => { }, async () => {
                console.log('Yes Pressed');
                try {
                    await makeApiRequest('delete', `${API_CONFIG.OTHER_INCOME}/${accountType}`, authToken, refreshToken, setAuthToken, setRefreshToken);
                    setToastMessage("Income account deleted successfully");
                    navigation.goBack();
                } catch (err) {
                    console.log("delete err: ", err)
                    handleAlertForError(err);
                }
            }, () => {
                console.log('No Pressed');
            }
            );
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const incomeAccountsData = await makeApiRequest('get', `${API_CONFIG.TRANSACTIONS}/income`, authToken, refreshToken, setAuthToken, setRefreshToken);
            setLoading(false);
            if (!isEmpty(incomeAccountsData)) {
                let isTransactionPresent = Object.values(incomeAccountsData).some(entry => entry.incomeType === accountType);
                return isTransactionPresent;
            }
            else {
                return false;
            }
        }
        catch (error) {
            handleAlertForError(error);
        }
    }

    const hideDatePicker = () => {
        setDatePickerVisibility(false);
    };

    const handleConfirm = (date) => {
        setChosenDate(date);
        hideDatePicker();
    };

    const validateTransaction = () => {
        if (!amount) {
            setError('Please enter amount.');
            return false;
        }
        else if (!comment) {
            setError('Please enter your comment.');
            return false;
        }
        setError('');
        return true;
    };

    const checkExistingIncomeAccounts = async () => {
        try {
            const incomeResponse = await makeApiRequest('get', API_CONFIG.OTHER_INCOME, authToken, refreshToken, setAuthToken, setRefreshToken);
            if (!isEmpty(incomeResponse)) {
                const dataArray = Object.entries(incomeResponse).map(([id, label]) => ({ label, value: id }));
                setIncomeAccountList(dataArray);
            }
        }
        catch (error) {
            handleAlertForError(error);
        }
    }

    const submitTransactionDetails = async () => {
        try {
            // const ownerData = await makeApiRequest('get', `${USERS_API}/${userData.factory}/${userData.username}`, authToken, refreshToken, setAuthToken, setRefreshToken);
            if (validateTransaction()) {
                setLoading(true);
                if (existingAmount) {
                    // if (amount - existingAmount <= ownerData.amount) {
                    await makeApiRequest("put",
                        `${API_CONFIG.TRANSACTIONS}/${transactionId}`,
                        authToken, refreshToken, setAuthToken, setRefreshToken, {
                        amount: amount,
                        date: formatDate(chosenDate),
                        time: chosenDate.toDateString() !== today.toDateString() ? "11:59:59 PM" : time.toLocaleTimeString("en-US"),
                        comment: comment,
                        incomeType: value,
                        actionBy: userData.username,
                    });
                    setLoading(false);
                    MixpanelTracker.sendAnalyticsEvent(EVENT_ACTIONS.OTHER_INCOME_EDIT_TRANSACTION, userData);
                    setToastMessage("Payment updated successfully");
                    setAmount("");
                    setComment("");
                    navigation.goBack();
                    // }
                    // else {
                    //     setLoading(false);
                    //     ShowAlert("Failed", "Your balance is insufficient!", "Ok", () => {
                    //         console.log('OK Pressed');
                    //     });
                    // }
                }
                else {
                    // if (parseFloat(ownerData.amount) >= parseFloat(amount)) {
                    await makeApiRequest("post",
                        `${API_CONFIG.TRANSACTIONS}/${userData.username.toLowerCase()}`,
                        authToken, refreshToken, setAuthToken, setRefreshToken, {
                        amount: amount,
                        date: formatDate(chosenDate),
                        time: chosenDate.toDateString() !== today.toDateString() ? "11:59:59 PM" : time.toLocaleTimeString("en-US"),
                        comment: comment,
                        actionBy: userData.username,
                        incomeType: value,
                    });
                    setLoading(false);
                    MixpanelTracker.sendAnalyticsEvent(EVENT_ACTIONS.OTHER_INCOME_YOU_GAVE_CLICKED, userData);
                    sendNotification(userData.factory, `Transaction for Other Income`, `${amount} Rs received for ${findLabelByValue(value)} in ${userData.username}`, authToken, refreshToken, setAuthToken, setRefreshToken);
                    setToastMessage("Payment added successfully");
                    setAmount("");
                    setComment("");
                    navigation.goBack();
                    // }
                    // else {
                    //     setLoading(false);
                    //     ShowAlert("Failed", "Your balance is insufficient!", "Ok", () => {
                    //         console.log('OK Pressed');
                    //     });
                    // }
                }
            }
        } catch (error) {
            setLoading(false);
            handleAlertForError(error);
        }
    }

    return (
        <View style={styles.container}>
            {loading && (
                <View style={styles.overlay}>
                    <ActivityIndicator size="large" color="#0000ff" />
                </View>
            )}
            <TextInput style={[styles.textInput, { fontWeight: 'bold', color: 'black' }]} editable={false} value={accountName || existingComment} />
            <TextInput
                placeholder='Enter Amount'
                value={amount}
                keyboardType="numeric"
                onChangeText={(text) => setAmount(removeLeadingZero(text))}
                style={[styles.textInput, isFocus === 'amount' && { borderColor: Colors.primary }]}
                onFocus={() => setIsFocus('amount')}
            />
            <TouchableOpacity onPress={() => setDatePickerVisibility(true)}>
                <View style={styles.view}>
                    <FontAwesome5
                        name="calendar"
                        size={24}
                        color={Colors.primary}
                    />
                    <Text style={styles.text}> {chosenDate.toDateString()}</Text>
                    <FontAwesome5
                        name="caret-down"
                        size={24}
                        color={Colors.primary}
                    />
                    <Popup visible={isDatePickerVisible} onClose={() => setDatePickerVisibility(false)}>
                        <DateTimePicker
                            mode="single"
                            date={chosenDate}
                            maxDate={today}
                            onChange={(param) => {
                                handleConfirm(new Date(param.date));
                                setDatePickerVisibility(false)
                            }}
                            headerButtonStyle={{ color: 'green' }}
                        />
                    </Popup>
                </View>
            </TouchableOpacity>
            <TextInput
                style={[styles.textInput, isFocus === 'comment' && { borderColor: Colors.primary }]}
                placeholder="Write your comment here..."
                value={comment}
                onChangeText={(text) => setComment(text)}
                onFocus={() => setIsFocus('comment')}
            />
            {error && <Text style={styles.errorText}>{error}</Text>}
            <Button
                onPress={submitTransactionDetails}
                btnLabel={`YOU RECEIVED ₹${amount}`}
                buttonStyle={styles.btnContainer}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center'
    },
    view: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 55,
        borderColor: '#636363',
        borderRadius: 6,
        paddingHorizontal: 8,
        margin: 12,
        padding: 12,
        width: '100%',
        backgroundColor: "white"
    },
    text: {
        marginLeft: 10,
        marginRight: 10
    },
    textInput: {
        borderWidth: 2,
        borderColor: '#636363',
        margin: 10,
        padding: 12,
        fontSize: 16,
        borderRadius: 6,
        width: '90%'
    },
    btnContainer: {
        paddingVertical: 20,
        paddingHorizontal: 40,
        width: '90%',
        position: 'absolute',
        bottom: 10,
        margin: 20,
        backgroundColor: Colors.secondary,
    },
    trashIcon: {
        right: 20,
        alignSelf: 'flex-end'
    },
    errorText: {
        color: 'red',
        marginBottom: 10,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000
    },
});

export default AddOtherIncome